import { Box } from 'MaterialUIComponents';
import { VideoAsset } from '$Utilities/models/videoViews';
import VideoPlayer from '../VideoPlayer/VideoPlayer';
import { useAiOverlayContext } from '$State/AiOverlay/AiOverlayContext';
import { React } from 'Imports';

interface VideoBoxProps {
    video: VideoAsset;
    transitionEffect: boolean;
    height?: number;
    maxHeight?: number;
    className?: string;
    onVideoDownloaded?: () => void;
}

const styles = require('./Layouts.scss') as {
    mainViewDiv: string;
    mainViewBox: string;
    opacityIn: string;
    opacityOut: string;
};

const VideoBox = (props: VideoBoxProps) => {
    const { aiOverlayOn, hasAiOverlayEverBeenOn } = useAiOverlayContext();

    // Only mount the AI overlay player once the toggle has actually been used for this event —
    // otherwise every viewer would load a second video stream they may never ask for.
    const shouldRenderAiPlayer = hasAiOverlayEverBeenOn && !!props.video.aiUrl;
    const title = props.video.channelNumber != null ? `Channel ${props.video.channelNumber} Video` : props.video.type;

    return (
        <Box
            className={`${props.className ?? styles.mainViewBox} ${props.transitionEffect ? styles.opacityIn : styles.opacityOut}`}
            sx={{ height: props.height }}
        >
            <div className={styles.mainViewDiv}>
                <div style={{ display: aiOverlayOn && shouldRenderAiPlayer ? 'none' : undefined }}>
                    <VideoPlayer
                        src={props.video.url}
                        title={title}
                        videoType={props.video.type}
                        channelNumber={props.video.channelNumber}
                        maxHeight={props.maxHeight}
                        onVideoDownloaded={props.onVideoDownloaded}
                        isActive={shouldRenderAiPlayer ? !aiOverlayOn : undefined}
                    />
                </div>
                {shouldRenderAiPlayer && (
                    <div style={{ display: aiOverlayOn ? undefined : 'none' }}>
                        <VideoPlayer
                            src={props.video.aiUrl!}
                            title={title}
                            videoType={props.video.type}
                            channelNumber={props.video.channelNumber}
                            maxHeight={props.maxHeight}
                            onVideoDownloaded={props.onVideoDownloaded}
                            isActive={aiOverlayOn}
                        />
                    </div>
                )}
            </div>
        </Box>
    );
};

export default VideoBox;
